import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft } = FiIcons;

export default function LegalLayout({ title, children }) {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-etera-ivory"
    >
      <div className="max-w-3xl mx-auto py-16 px-6">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-etera-charcoal hover:text-etera-gold transition-colors duration-300 mb-12 group"
        >
          <SafeIcon icon={FiArrowLeft} className="transition-transform group-hover:-translate-x-1" />
          <span className="text-sm font-medium tracking-widest uppercase text-xs">Volver al inicio</span>
        </Link>

        <header className="mb-12">
          <h1 className="text-4xl md:text-5xl font-serif text-etera-black tracking-tight">
            {title}
          </h1>
          <div className="h-px w-20 bg-etera-gold mt-6" />
        </header>

        <div className="prose prose-etera max-w-none">
          <div className="space-y-8 text-etera-charcoal leading-relaxed font-sans">
            {children}
          </div>
        </div>
      </div>
    </motion.div>
  );
}